import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../Services/auth.service';
import { NavMenuItems } from '../Models/NavMenuItems';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Check if user is logged in
    const userId = localStorage.getItem("UserId");
    if (!userId) {
      this.router.navigate(['/'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    // Check if user is active
    if (!this.authService.isUserActive()) {
      this.router.navigate(['/'], {
        queryParams: { returnUrl: state.url, inactive: true }
      });
      return false;
    }

    // Get required permissions from route data
    const requiredPermissions = route.data['permissions'] as (keyof NavMenuItems)[];
    const requiredReports = route.data['reports'] as string[];
    const permissionCheckType = route.data['permissionCheckType'] || 'any'; // 'any' or 'all'

    // If no specific permissions required, allow access
    if ((!requiredPermissions || requiredPermissions.length === 0) &&
      (!requiredReports || requiredReports.length === 0)) {
      return true;
    }

    // Check permissions if required
    if (requiredPermissions && requiredPermissions.length > 0) {
      let hasPermission = false;

      if (permissionCheckType === 'all') {
        hasPermission = this.authService.hasAllPermissions(requiredPermissions);
      } else {
        hasPermission = this.authService.hasAnyPermission(requiredPermissions);
      }

      if (!hasPermission) {
        this.router.navigate(['/unauthorized']);
        return false;
      }
    }

    // Check report access if required
    if (requiredReports && requiredReports.length > 0) {
      const hasReportAccess = this.authService.hasAnyReportAccess(requiredReports);

      if (!hasReportAccess) {
        this.router.navigate(['/unauthorized']);
        return false;
      }
    }

    return true;
  }
}
